enum FinancialType {
	PROGNOSIS = 'prognose',
	FINANCIAL_REGISTRATION = 'financial_registration',
	INVOICE_LINE = 'invoice_line'
}

export default FinancialType
